<template>
  <div id="app">
    <Header v-bind:headState="getHeadState"/>
    <main>
      <!-- <transition :name="transitionName"> -->
      <transition>
        <router-view/>
      </transition>
    </main>
    <Sub />
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Sub from '@/components/Sub.vue'
import Footer from '@/components/Footer.vue'
import isMobile from 'ismobilejs'
import { mapGetters } from 'vuex';

export default {
  name: 'app',
  components: {
    Header,
    Sub,
    Footer,
  },
  data() {
    return {
      transitionName: "",
      headState: 'search'
    };
  },
  watch: {
    $route(to, from) {
      // console.log(from.meta.page)
      if(from.name !== null && isMobile.phone == true){
        this.transitionName = to.meta.page > from.meta.page ? "next" : "prev";
      }
      if(to.meta.headState !== null && from.meta.headState !== null && from.meta.headState !== to.meta.headState){
          this.headState = to.meta.headState
      }
    }
  },
  computed: {
    ...mapGetters([
      'getHeadState',
    ])
  }
}
</script>
<style>
* {
    box-sizing: border-box;
}
body{
  margin: 0;
  background-color: #fafafa;
  font-size: 12px;
  height: 100%;
}

ul, dl {
  padding: 0;
  margin: 0;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
  padding-bottom: 60px;
}

.con {
    max-width: 980px;
    width: 100%;
    margin: 0 auto;
    position: relative;
}

.tac {
    text-align: center;
}
.tal {
    text-align: left;
}
.fsS {
    font-size: .9em;
    line-height: 1.3em;
}

.nmg{
  margin: 0;
}

.pginner{
  padding: 8px;
}

/*label*/
.lbl{display: inline-block; font-size: .8em; padding: 2px 8px; border-radius: 2px; color: #FFF;}
.lbl-official{background-color: #ff3300;}
.blk{display: block;}

/*bg*/
.bg-golf{background-color: #c1e1dc;}
.bg-golf-dp{background-color: #a1be95;}
.bg-tennis{background-color: #ffeb94;}
.bg-yoga-fitness{background-color: #ffccac;}
.bg-running{background-color: #4f6457;}
.bg-walking{background-color: #db9501;}
.bg-tulip{background-color: #f18d9e;}
.bg-gen-0{background-color: #98c73d;}
.bg-men, .bg-gen-2{background-color: #4cb5f5;}
.bg-ladies, .bg-gen-1{background-color: #F98866;}
.bg-gen-3{background-color: #CCFF33;}
.bgtwtr{background-color: #00aced;}
.bgfcbk{background-color: #305097;}
.bgggrp{background-color: #db4a39;}

.tblcl{display: table-cell; vertical-align: middle;}

.hide{display: none;}


main {
  min-height: 100vh;
  margin: auto auto;
  grid-template: "main";
  flex: 1;
  background-color: white;
  position: relative;
  z-index: 0;
  overflow-x: hidden;
}

.itemListBox{

}

.itemList{
  display: flex;
  flex-wrap: wrap;
  padding: 0 8px;
  list-style: none;
  margin: 0 -.6%;
}

.itemList li{
  width: 32%;
  position: relative;
  margin: 8px .6%;
  background-color: #FFF;
  border-radius: 3px;
  border: 1px solid #EEE;
}

.itemCvr{
  width: 100%;
  z-index: 10;
  position: relative;
  padding: 8px 8px 0;
}

.imgmain{
  height: 120px;
  overflow: hidden;
}

.itemImgDf{
  display: flex;
  align-items: center;
  height: 100%;
  z-index: -1;
  margin: 0;
  padding: 32px;
  position: absolute;
  top: 0;
  left: 0;
}

.itemImgDf img{
  filter: invert(10%);
}


.imgmain img{
  max-width: 100%;
}

.imgvari{
  display: flex;
  justify-content: center;
  margin: 0;
}

.imgvariimg{
  height: 36px;
  overflow: hidden;
}

.imgvariimg a img.lazyloaded{
  width: 27px;
  vertical-align: bottom;
}

.itemImgLink{
  display: block;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

.itmgenicon{position: absolute; top: 3px; right: 3px; z-index: 11;}
.genselicon{
  display: block;
  width: 24px;
  height: 24px;
  border: 2px solid #EEE;
  padding: 4px;
  border-radius: 50%;
}

.itmdtl{
  padding: 8px;
  text-align: center;
}

.itmbdnm {
  padding: 4px 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 1.05em;
  line-height: .9em;
  margin-top: 0;
}

.itmnm {
  font-size: 1.15em;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 4px 0;
}

.itmprc {
  font-weight: bold;
  margin: 0;
  font-size: 1rem;
  color: #FF3300;
}

.sticky{
  position: sticky;
}


/*pager*/
.pagerbox { width: auto; line-height: 34px; text-align: center;}
.pagerL { display: inline-block; padding: 4px 6px; vertical-align: middle; line-height: 34px; text-align: center;}
.pagerL a{ color: #FFF; text-decoration: none; background-color: #66d42a; border-radius: 50%; display: block; width: 34px; height: 34px; line-height: 30px; vertical-align: middle; box-sizing: border-box; border: 2px solid #66d42a;}
.pagerL.active a{ width: 34px; height: 34px; line-height: 30px; box-sizing: border-box; border: 2px solid #66d42a; color: #66d42a; border-radius: 50%; display: inline-block; vertical-align: middle; background-color: #FFF;}
.pagerL a:hover{background-color: #FFF; color: #66d42a;}

.pc-none{
  display: block;
}


main > * {
  grid-area: main; /* Transition: make sections overlap on same cell */
  background-color: white;
  position: relative;
}

main > :first-child {
  z-index: 1; /* Prevent flickering on first frame when transition classes not added yet */
}

.fclg2 {
    color: #CCC;
}

.fsXXS {
    font-size: .65em;
    line-height: 1.3em;
}

.t-left{
  text-align: left;
}

.mh {
    font-weight: normal;
    text-shadow: #fff 1px 1px 1px;
}

/* Transitions */

.next-leave-to {
  animation: leaveToLeft 600ms both cubic-bezier(0.165, 0.84, 0.44, 1);
  z-index: 0;
}

.next-enter-to {
  animation: enterFromRight 300ms both cubic-bezier(0.165, 0.84, 0.44, 1);
  z-index: 1;
}

.prev-leave-to {
  animation: leaveToRight 300ms both cubic-bezier(0.165, 0.84, 0.44, 1);
  z-index: 1;
}

.prev-enter-to {
  animation: enterFromLeft 500ms both cubic-bezier(0.165, 0.84, 0.44, 1);
  z-index: 0;
}

@keyframes leaveToLeft {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-25%);
    filter: brightness(0.5);
  }
}

@keyframes enterFromLeft {
  from {
    transform: translateX(-25%);
    filter: brightness(0.5);
  }
  to {
    transform: translateX(0);
  }
}

@keyframes leaveToRight {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(100%);
  }
}

@keyframes enterFromRight {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}


@media screen and (min-width:767px) {
  main, main > * {
    background : none;
  }
  .pcinner{
    max-width: 980px;
    margin: auto auto;
  }
  .pginner{
    padding: 0;
  }
  .itemList{
    padding: 0;
    margin: 8px -1%;
  }
  .itemList li{
    width: 18%;
    margin: 8px 1%;
  }
  .imgmain{
    height: 200px;
  }
  .pc-none{
    display: none;
  }

}

</style>
